import React from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import Select from 'react-select';

class SelectTranslated extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape()),
    labelKey: PropTypes.string,
  };
  static defaultProps = {
    options: undefined,
    labelKey: undefined,
  };

  render() {
    const { intl, options, labelKey } = this.props;

    return (
      <Select
        disabled={!options || !options.length}
        {...this.props}
        options={
          options && options.length && options.map
            ? options.map(option => ({
                ...option,
                ...(option[labelKey]
                  ? { [labelKey]: intl.formatMessage({ id: option[labelKey] }) }
                  : {}),
              }))
            : []
        }
        labelKey={labelKey}
      />
    );
  }
}

export default injectIntl(SelectTranslated);



// WEBPACK FOOTER //
// ./src/desktop/components/SearchPanelV2/SelectTranslated/SelectTranslated.js